module.exports = __webpack_public_path__ + "img/twitter.66eeb6d8.jpg";